// German for the projection console (tab-portal-admin). Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── masthead / page states ─────────────────────────────────────────────────
  'Client portal': 'Kundenportal',
  'No engagement selected': 'Kein Auftrag ausgewählt',
  'Portal access and publication are decided per engagement — the master switch, the object-type matrix and every publish flag hang off one engagement id.':
    'Portalzugang und Veröffentlichung werden pro Auftrag entschieden — Hauptschalter, Objekttyp-Matrix und jedes Veröffentlichungs-Flag hängen an einer Auftrags-ID.',
  'Resolving what the client would find…': 'Wird ermittelt, was der Kunde vorfinden würde…',
  'The projection could not be computed': 'Die Projektion konnte nicht berechnet werden',
  'GET /api/portal-admin/projection did not answer.': 'GET /api/portal-admin/projection hat nicht geantwortet.',
  'portal on': 'Portal aktiv',
  'portal off': 'Portal aus',
  'The publish lists could not be read.': 'Die Veröffentlichungslisten konnten nicht gelesen werden.',
  'The publish lists could not be read': 'Die Veröffentlichungslisten konnten nicht gelesen werden',
  'No conversation on this engagement matches “{key}”.': 'Keine Konversation in diesem Auftrag passt zu «{key}».',

  // ── the rail ───────────────────────────────────────────────────────────────
  'REACHABLE': 'ERREICHBAR',
  'SHARED': 'GETEILT',
  'CAN SIGN IN': 'ANMELDBAR',
  'CLIENT LAST SEEN': 'KUNDE ZULETZT',
  'AWAITING YOU': 'WARTET AUF SIE',
  'the projection': 'die Projektion',
  'what is shared': 'was geteilt ist',
  'people': 'Personen',
  'the thread': 'den Thread',
  'Open {what}': '{what} öffnen',
  'the projection has not answered yet': 'die Projektion hat noch nicht geantwortet',
  'off': 'inaktiv',
  'on‖state': 'aktiv',
  'views': 'Ansichten',
  'the master switch is off': 'der Hauptschalter ist aus',
  '{n} of them would open empty': '{n} davon würden leer öffnen',
  'nothing renders': 'nichts wird angezeigt',
  'of {total}': 'von {total}',
  '{n} staged, not written': '{n} vorgemerkt, nicht geschrieben',
  'nothing published': 'nichts veröffentlicht',
  '{sponsors} sponsor · {pending} invite pending': '{sponsors} Sponsor · {pending} Einladung ausstehend',
  'nobody invited': 'niemand eingeladen',
  'never': 'nie',
  'd ago‖unit': 'T. her',
  'no portal action on record': 'keine Portalaktion auf Akte',
  'comment': 'Kommentar',
  'comments': 'Kommentare',
  '{n} day': '{n} Tag',
  '{n} days': '{n} Tage',
  'nothing unanswered': 'nichts unbeantwortet',

  // ── the master switch band ─────────────────────────────────────────────────
  'The portal is': 'Das Portal ist',
  'for this engagement. Publication decides the rest.': 'für diesen Auftrag. Die Veröffentlichung entscheidet den Rest.',
  'Every portal call is refused before publication is even consulted — grants and publish flags are kept, and take effect the moment it flips.':
    'Jeder Portalaufruf wird abgewiesen, bevor die Veröffentlichung überhaupt geprüft wird — Berechtigungen und Veröffentlichungs-Flags bleiben erhalten und gelten, sobald er umgelegt wird.',
  'What they see': 'Was sie sehen',
  'Switch the portal off': 'Portal ausschalten',
  'Switch the portal on': 'Portal einschalten',

  // ── zone 1 · next move ─────────────────────────────────────────────────────
  'Next move': 'Nächster Zug',
  '{n} open': '{n} offen',
  '{n} more, ranked': '{n} weitere, nach Rang',

  // ── zone 2 · what the client would find ────────────────────────────────────
  'What the client would find': 'Was der Kunde vorfinden würde',
  '{n} of {total} views render': '{n} von {total} Ansichten werden angezeigt',
  'the portal is off — nothing renders': 'das Portal ist aus — nichts wird angezeigt',
  'Open the full preview →': 'Vollständige Vorschau öffnen →',
  'The visibility matrix': 'Die Sichtbarkeitsmatrix',
  'Nothing renders. With the master switch off every portal call is refused before publication is even consulted — a client who follows an invite gets a sign-in page and':
    'Nichts wird angezeigt. Bei ausgeschaltetem Hauptschalter wird jeder Portalaufruf abgewiesen, bevor die Veröffentlichung überhaupt geprüft wird — ein Kunde, der einer Einladung folgt, erhält eine Anmeldeseite und',
  '“this engagement is not shared with you”': '«dieser Auftrag ist nicht mit Ihnen geteilt»',
  '{n} view suppressed by one boolean. Their publication settings are kept and take effect the moment it flips.':
    '{n} Ansicht durch einen Schalter unterdrückt. Ihre Veröffentlichungseinstellungen bleiben erhalten und gelten, sobald er umgelegt wird.',
  '{n} views suppressed by one boolean. Their publication settings are kept and take effect the moment it flips.':
    '{n} Ansichten durch einen Schalter unterdrückt. Ihre Veröffentlichungseinstellungen bleiben erhalten und gelten, sobald er umgelegt wird.',
  'is hidden — the tab is not in their navigation': 'ist verborgen — der Tab ist nicht in ihrer Navigation',
  'renders, and finds nothing': 'wird angezeigt und findet nichts',
  '0 of': '0 von',
  'of': 'von',
  'published': 'veröffentlicht',
  'always present': 'immer vorhanden',
  'Resolved from the same three gates the portal itself applies — engagement switch, object-type visibility, row flag. Nothing here is a screenshot and nothing here is a guess.':
    'Ermittelt aus denselben drei Gates, die das Portal selbst anwendet — Auftragsschalter, Objekttyp-Sichtbarkeit, Zeilen-Flag. Nichts hier ist ein Screenshot und nichts hier ist geraten.',
  'Signet portal': 'Signet-Portal',
  'no tabs': 'keine Tabs',
  'Including {n} staged change — nothing is written yet.': 'Inklusive {n} vorgemerkter Änderung — noch nichts geschrieben.',
  'Including {n} staged changes — nothing is written yet.': 'Inklusive {n} vorgemerkter Änderungen — noch nichts geschrieben.',
  'Preview pins day paper — the portal has no theme toggle.': 'Die Vorschau bleibt auf hellem Papier — das Portal hat keinen Design-Schalter.',

  // ── zone 3 · what is shared ────────────────────────────────────────────────
  'What is shared': 'Was geteilt ist',
  '{n} of {total} rows': '{n} von {total} Zeilen',
  '{n} of {total} types visible': '{n} von {total} Typen sichtbar',
  '{n} staged': '{n} vorgemerkt',
  'The shared tallies': 'Die Teilungszähler',
  'Reading the register…': 'Register wird gelesen…',
  'Nothing loaded.': 'Nichts geladen.',
  'no per-row flag': 'kein Zeilen-Flag',
  '{n} draft shared': '{n} Entwurf geteilt',
  '{n} drafts shared': '{n} Entwürfe geteilt',
  'excluded': 'ausgeschlossen',
  'visible, nothing exists': 'sichtbar, nichts vorhanden',
  'no client view lists these': 'keine Kundenansicht listet diese',
  '{label} visibility': 'Sichtbarkeit {label}',
  'hidden': 'verborgen',
  'read‖access': 'lesen',
  'read + act': 'lesen + handeln',
  'read_act': 'lesen + handeln',
  'not in the portal': 'nicht im Portal',
  'the type gate is the whole decision': 'das Typ-Gate ist die ganze Entscheidung',
  '{n} row on record, none reachable': '{n} Zeile auf Akte, keine erreichbar',
  '{n} rows on record, none reachable': '{n} Zeilen auf Akte, keine erreichbar',
  'in scope shared': 'im Umfang geteilt',
  'they can {act}': 'sie können: {act}',
  'Defects carry no': 'Mängel haben keine Spalte',
  'column. The client raised them, so the type gate is the only decision there is.': '– der Kunde hat sie erfasst, also ist das Typ-Gate die einzige Entscheidung.',
  'Nothing of this kind exists in': 'Noch nichts dieser Art in',
  'yet.': 'vorhanden.',
  'The tab would still render for the client, and it would be empty.': 'Der Tab würde dem Kunden trotzdem angezeigt, und er wäre leer.',
  'Share every held row in scope': 'Jede übernommene Zeile im Umfang teilen',
  'Share none': 'Nichts teilen',
  'showing': 'Anzeige',
  'exclusion': 'Ausschluss',
  'draft, and shared': 'Entwurf, und geteilt',
  'revised {date}, after the publish pass': 'revidiert {date}, nach dem Veröffentlichungslauf',
  'flagged, and the portal still will not list it — it is {status}': 'markiert, und das Portal listet sie trotzdem nicht — sie ist {status}',
  'to share': 'wird geteilt',
  'to hide': 'wird verborgen',
  'shared': 'geteilt',
  'not shared': 'nicht geteilt',
  'Show the remaining': 'Weitere anzeigen:',

  // ── zone 4 · who can sign in ───────────────────────────────────────────────
  'Who can sign in': 'Wer sich anmelden kann',
  '{n} account': '{n} Konto',
  '{n} accounts': '{n} Konten',
  'Reading the accounts…': 'Konten werden gelesen…',
  'Nobody at {client} can sign in.': 'Niemand bei {client} kann sich anmelden.',
  '{n} contact is already on the client record — a portal account can be made from one without retyping it.':
    '{n} Kontakt steht bereits im Kundendatensatz — ein Portalkonto lässt sich daraus anlegen, ohne ihn neu einzutippen.',
  '{n} contacts are already on the client record — a portal account can be made from one without retyping it.':
    '{n} Kontakte stehen bereits im Kundendatensatz — ein Portalkonto lässt sich daraus anlegen, ohne sie neu einzutippen.',
  'No contact is on the client record either, so there is nobody to make an account from yet.':
    'Auch im Kundendatensatz steht kein Kontakt, es gibt also noch niemanden, aus dem ein Konto angelegt werden könnte.',
  'no email on record': 'keine E-Mail auf Akte',
  'sponsor on the record': 'Sponsor laut Akte',
  'no role on record': 'keine Rolle auf Akte',
  'no portal account': 'kein Portalkonto',
  'This contact has no email address on record': 'Für diesen Kontakt ist keine E-Mail-Adresse hinterlegt',
  'Invite as sponsor': 'Als Sponsor einladen',
  'Invite as reviewer': 'Als Reviewer einladen',
  'The portal is off, so an invite issued now cannot be accepted. Switch it on in the masthead, or the link lands on a locked door.':
    'Das Portal ist aus, eine jetzt verschickte Einladung kann also nicht angenommen werden. Schalten Sie es im Kopfbereich ein, sonst landet der Link vor verschlossener Tür.',
  'Create an account by hand': 'Konto von Hand anlegen',
  'linked to the contact record': 'mit dem Kontaktdatensatz verknüpft',
  'disabled': 'deaktiviert',
  'active': 'aktiv',
  'invite expired': 'Einladung abgelaufen',
  'invited': 'eingeladen',
  'no invite': 'keine Einladung',
  'Role for {name}': 'Rolle für {name}',
  'sponsor': 'Sponsor',
  'reviewer': 'Reviewer',
  'last seen': 'zuletzt gesehen',
  'portal action': 'Portalaktion',
  'portal actions': 'Portalaktionen',
  'link expires': 'Link läuft ab am',
  'signed in, nothing done yet': 'angemeldet, noch nichts getan',
  'never signed in': 'nie angemeldet',
  'granted {codes}': 'berechtigt für {codes}',
  'Copy link': 'Link kopieren',
  'Re-invite': 'Erneut einladen',
  'Invite': 'Einladen',
  'Revoke': 'Widerrufen',
  'Grants': 'Berechtigungen',
  'Re-enable': 'Reaktivieren',
  'Disable': 'Deaktivieren',
  'Delete': 'Löschen',
  'New portal user': 'Neuer Portalbenutzer',
  'nothing — the account is disabled': 'nichts — das Konto ist deaktiviert',
  'nothing until the invite is accepted': 'nichts, bis die Einladung angenommen ist',
  '{read} (only a sponsor acts)': '{read} (nur ein Sponsor handelt)',
  'read the overview, and nothing else': 'die Übersicht lesen, sonst nichts',

  // ── zone 5 · conversation ──────────────────────────────────────────────────
  'Conversation': 'Konversation',
  'awaiting-you not counted': 'wartet-auf-Sie nicht gezählt',
  '{n} awaiting you of {total}': '{n} von {total} warten auf Sie',
  'The awaiting-you list': 'Die Liste «wartet auf Sie»',
  'Reading the threads…': 'Threads werden gelesen…',
  'Nothing has been said. A client comment lands here with the statement it is about, so the answer does not need a second tab.':
    'Es wurde nichts gesagt. Ein Kundenkommentar landet hier zusammen mit der Aussage, um die es geht, damit die Antwort keinen zweiten Tab braucht.',
  'Open {ref} in the Register': '{ref} im Register öffnen',
  'Open the Register': 'Register öffnen',
  'state unknown': 'Status unbekannt',
  'awaiting your reply': 'wartet auf Ihre Antwort',
  'answered': 'beantwortet',
  'Open the thread →': 'Thread öffnen →',
  'the statement they are asking about': 'die Aussage, nach der sie fragen',
  'you': 'Sie',
  'client': 'Kunde',
  'Reply as the consultant': 'Als Berater antworten',
  'This appears on {ref} in their portal.': 'Dies erscheint bei {ref} in ihrem Portal.',
  'the object': 'dem Objekt',
  'Sending…': 'Wird gesendet…',
  'Send': 'Senden',
  'Open it in the Register': 'Im Register öffnen',

  // ── staging bar / dialogues ────────────────────────────────────────────────
  'share': 'teilen',
  'stop sharing': 'nicht mehr teilen',
  'not written yet': 'noch nicht geschrieben',
  '{n} of them is still draft': '{n} davon ist noch Entwurf',
  '{n} of them are still draft': '{n} davon sind noch Entwurf',
  '{n} is an exclusion': '{n} ist ein Ausschluss',
  '{n} are exclusions': '{n} sind Ausschlüsse',
  'Discard': 'Verwerfen',
  'Publish these': 'Diese veröffentlichen',
  'Change what the client can see': 'Ändern, was der Kunde sehen kann',
  'Writing…': 'Wird geschrieben…',
  'Write {n} change': '{n} Änderung schreiben',
  'Write {n} changes': '{n} Änderungen schreiben',
  'Share': 'Teilen',
  'and': 'und',
  'for': 'für',
  'of them is still': 'davon ist noch',
  'of them are still': 'davon sind noch',
  'draft': 'Entwurf',
  'in the register. A draft statement shown to a client reads as a commitment.': 'im Register. Eine Entwurfsaussage, die ein Kunde sieht, liest sich als Zusage.',
  'is descoped or explicitly out of scope': 'ist aus dem Umfang genommen oder ausdrücklich ausserhalb des Umfangs',
  'are descoped or explicitly out of scope': 'sind aus dem Umfang genommen oder ausdrücklich ausserhalb des Umfangs',
  'Showing an exclusion to a client is a contractual statement about what you are': 'Einen Ausschluss dem Kunden zu zeigen ist eine vertragliche Aussage darüber, was Sie',
  'not': 'nicht',
  'doing — publish it only if you mean to make that point.': 'tun — veröffentlichen Sie ihn nur, wenn Sie genau das sagen wollen.',
  'Switching…': 'Wird umgeschaltet…',
  'Switch it off': 'Ausschalten',
  'Every portal call for': 'Jeder Portalaufruf für',
  'is refused from the moment this is written — anyone signed in loses the engagement on their next click.':
    'wird abgewiesen, sobald dies geschrieben ist — wer angemeldet ist, verliert den Auftrag beim nächsten Klick.',
  'published row': 'veröffentlichte Zeile',
  'published rows': 'veröffentlichte Zeilen',
  'account': 'Konto',
  'accounts': 'Konten',
  'stay exactly as they are and take effect again the moment it is switched back on.': 'bleiben genau wie sie sind und gelten wieder, sobald es wieder eingeschaltet wird.',
  'Portal account for {name}': 'Portalkonto für {name}',
  'Name': 'Name',
  'Email': 'E-Mail',
  'Role': 'Rolle',
  'reviewer — runs UAT, comments, raises defects': 'Reviewer — führt UAT durch, kommentiert, meldet Mängel',
  'sponsor — also signs the SOW, decides CRs, signs acceptance': 'Sponsor — unterzeichnet zudem das SOW, entscheidet Änderungsanträge, unterzeichnet die Abnahme',
  'The account is granted': 'Das Konto erhält',
  'straight away and cannot sign in until an invite is accepted and a password set.': 'sofort, kann sich aber erst anmelden, wenn eine Einladung angenommen und ein Passwort gesetzt ist.',
  'The contact record is linked, so the two never drift apart.': 'Der Kontaktdatensatz ist verknüpft, die beiden laufen also nie auseinander.',
  'The portal is off for this engagement, so the account will exist and reach nothing until the master switch is on.':
    'Das Portal ist für diesen Auftrag aus; das Konto wird also existieren und nichts erreichen, bis der Hauptschalter eingeschaltet ist.',
  'Cancel': 'Abbrechen',
  'Create': 'Erstellen',
  'Engagement grants — {name}': 'Auftragsberechtigungen — {name}',
  'A grant only covers engagements of {client}. Without one, the portal returns “not shared with you”.':
    'Eine Berechtigung gilt nur für Aufträge von {client}. Ohne sie antwortet das Portal mit «nicht mit Ihnen geteilt».',
  'Done': 'Fertig',
  'Delete {name}': '{name} löschen',
  '{name} cannot be deleted': '{name} kann nicht gelöscht werden',
  'This account': 'Dieses Konto',
  'Deleting…': 'Wird gelöscht…',
  'Delete permanently': 'Endgültig löschen',
  'Already disabled': 'Bereits deaktiviert',
  'Disable instead': 'Stattdessen deaktivieren',
  'This account has left no record behind, so it can simply go. An account that has signed, tested or raised anything is disabled instead.':
    'Dieses Konto hat keine Spuren hinterlassen und kann daher einfach entfernt werden. Ein Konto, das etwas unterzeichnet, getestet oder gemeldet hat, wird stattdessen deaktiviert.',
  'Any outstanding invite link dies with it. The audit log keeps the record.': 'Ein offener Einladungslink erlischt damit. Der Prüfpfad behält den Eintrag.',

  // ── toasts ─────────────────────────────────────────────────────────────────
  'The portal is on — grants and publication settings now take effect': 'Das Portal ist eingeschaltet — Berechtigungen und Veröffentlichungseinstellungen gelten jetzt',
  'The portal is off — clients lose access immediately': 'Das Portal ist ausgeschaltet — Kunden verlieren den Zugang sofort',
  'Could not change the portal switch': 'Der Portalschalter konnte nicht umgelegt werden',
  'Could not save the publication setting': 'Die Veröffentlichungseinstellung konnte nicht gespeichert werden',
  '{table} was refused': '{table} wurde abgelehnt',
  '{n} row written': '{n} Zeile geschrieben',
  '{n} rows written': '{n} Zeilen geschrieben',
  'Reply posted — the client sees it on the object': 'Antwort gesendet — der Kunde sieht sie am Objekt',
  'Could not post the reply': 'Die Antwort konnte nicht gesendet werden',
  '{name} created and granted {code}': '{name} angelegt und für {code} berechtigt',
  'Could not create the portal user': 'Der Portalbenutzer konnte nicht angelegt werden',
  'Invite issued for {name} — the link is on their row': 'Einladung für {name} erstellt — der Link steht in der Zeile',
  'Could not issue the invite': 'Die Einladung konnte nicht erstellt werden',
  'The outstanding invite for {name} is dead': 'Die offene Einladung für {name} ist erloschen',
  'Could not revoke the invite': 'Die Einladung konnte nicht widerrufen werden',
  'Invite link copied': 'Einladungslink kopiert',
  'Clipboard blocked — select the link and copy it manually': 'Zwischenablage blockiert — markieren Sie den Link und kopieren Sie ihn von Hand',
  'Could not change the grant': 'Die Berechtigung konnte nicht geändert werden',
  '{name} re-enabled': '{name} reaktiviert',
  '{name} disabled': '{name} deaktiviert',
  'Could not update the user': 'Der Benutzer konnte nicht aktualisiert werden',
  'Could not change the role': 'Die Rolle konnte nicht geändert werden',
  'Could not work out what removing this account would do': 'Es liess sich nicht ermitteln, was das Entfernen dieses Kontos bewirken würde',
  '{name} disabled — access is gone, the record stands': '{name} deaktiviert — der Zugang ist weg, der Eintrag bleibt',
  '{name} removed': '{name} entfernt',
  'Could not remove the user': 'Der Benutzer konnte nicht entfernt werden',
  'Could not create a preview link': 'Der Vorschaulink konnte nicht erstellt werden',

  // ── the miniature ──────────────────────────────────────────────────────────
  'Password': 'Passwort',
  'Sign in': 'Anmelden',
  'this engagement is not shared with you': 'dieser Auftrag ist nicht mit Ihnen geteilt',
  'No view renders for this client.': 'Für diesen Kunden wird keine Ansicht angezeigt.',
  'The overview summarises the tabs below': 'Die Übersicht fasst die Tabs unten zusammen',
  'Nothing has been published to you yet.': 'Für Sie wurde noch nichts veröffentlicht.',
  'This tab is in their navigation and it is empty.': 'Dieser Tab ist in ihrer Navigation und er ist leer.',
  'is': 'ist',
  '0 of {total} rows published.': '0 von {total} Zeilen veröffentlicht.',
  'more': 'weitere',

  // ── portal vocabulary (src/shared/portalViews.ts, wrapped at the render site) ──
  'Requirements': 'Anforderungen',
  'Acceptance criteria': 'Abnahmekriterien',
  'Deliverables': 'Arbeitsergebnisse',
  'Documents': 'Dokumente',
  'Test cases': 'Testfälle',
  'Milestones': 'Meilensteine',
  'SOW versions': 'SOW-Versionen',
  'Change requests': 'Änderungsanträge',
  'Acceptance records': 'Abnahmeprotokolle',
  'Defects': 'Mängel',
  'requirements': 'Anforderungen',
  'acceptance criteria': 'Abnahmekriterien',
  'deliverables': 'Arbeitsergebnisse',
  'documents': 'Dokumente',
  'test cases': 'Testfälle',
  'milestones': 'Meilensteine',
  'sow versions': 'SOW-Versionen',
  'change requests': 'Änderungsanträge',
  'acceptance records': 'Abnahmeprotokolle',
  'defects': 'Mängel',
  'Overview': 'Übersicht',
  'Statement of work': 'Leistungsbeschreibung',
  'UAT': 'UAT',
  'Acceptance': 'Abnahme',
  'overview': 'Übersicht',
  'statement of work': 'Leistungsbeschreibung',
  'uat': 'UAT',
  'acceptance': 'Abnahme',
  'read the statements': 'die Aussagen lesen',
  'comment · propose a change': 'kommentieren · Änderung vorschlagen',
  'read the criteria, nested under the requirement they test': 'die Kriterien lesen, eingebettet unter der Anforderung, die sie prüfen',
  'named on other objects; no client view lists these': 'auf anderen Objekten genannt; keine Kundenansicht listet diese',
  'read · download': 'lesen · herunterladen',
  'download · upload new': 'herunterladen · neu hochladen',
  'read the cases': 'die Testfälle lesen',
  'record pass / fail / blocked': 'bestanden / fehlgeschlagen / blockiert erfassen',
  'sponsor signs → creates the baseline': 'Sponsor unterzeichnet → erstellt die Baseline',
  'read the requests': 'die Anträge lesen',
  'sponsor approves or rejects': 'Sponsor genehmigt oder lehnt ab',
  'read the record': 'das Protokoll lesen',
  'sponsor signs': 'Sponsor unterzeichnet',
  'read the defects they raised': 'die gemeldeten Mängel lesen',
  'raise a defect': 'Mangel melden',
  'the summary of everything below': 'die Zusammenfassung von allem unten',
  'sponsor signs → creates the baseline (sponsor only)': 'Sponsor unterzeichnet → erstellt die Baseline (nur Sponsor)',
  'sponsor approves or rejects (sponsor only)': 'Sponsor genehmigt oder lehnt ab (nur Sponsor)',
  'sponsor signs (sponsor only)': 'Sponsor unterzeichnet (nur Sponsor)',

  // ── engagement phases (rendered raw from the server) ───────────────────────
  'qualify': 'Qualifizierung',
  'discovery': 'Discovery',
  'design': 'Konzeption',
  'contracting': 'Vertrag',
  'mobilise': 'Mobilisierung',
  'implement': 'Umsetzung',
  'handover': 'Übergabe',
  'close': 'Abschluss',

  // ── row statuses (rendered raw from the register) ──────────────────────────
  'proposed': 'vorgeschlagen',
  'held': 'übernommen',
  'pending': 'ausstehend',
  'accepted': 'abgenommen',
  'rejected': 'abgelehnt',
  'ready': 'bereit',
  'dropped': 'verworfen',
  'failed': 'fehlgeschlagen',
  'passed': 'bestanden',
  'blocked': 'blockiert',
  'descoped': 'aus dem Umfang genommen',
  'baselined': 'in der Baseline',
  'delivered': 'geliefert',
  'planned': 'geplant',
  'in_progress': 'in Arbeit',
  'confirmed': 'bestätigt',
  'signed': 'unterzeichnet',
  'superseded': 'ersetzt',
  'open': 'offen',
  'resolved': 'gelöst',
  'approved': 'genehmigt',
}, 'PortalAdminPage');
